import React from 'react';
import { className, safeGet } from 'utils';
import styles from './iconCTAGridItem.module.scss';
import PropTypes from 'prop-types';
import { Link } from 'components';

const IconCTAGridItem = props => {
  const {
    url: imageURL,
    description: imageDescription,
    title: imageTitle,
    headline,
    intro,
    ctaUrl,
  } = safeGet(
    props,
    ['image', 'file', 'url'],
    ['image', 'title'],
    ['image', 'description'],
    'headline',
    'intro',
    'ctaUrl',
  );

  if (!headline) {
    return null;
  }

  return (
    <li {...className(styles.item, styles.itemWithImage)}>
      <div className={styles.itemInner}>
        <div className={styles.featuredImgWrapper}>
          <Link to={ctaUrl}>
            <img
              className={styles.featuredImg}
              src={imageURL}
              alt={imageDescription || imageTitle}
            />
          </Link>
        </div>
        <div className={styles.text}>
          <Link to={ctaUrl}>
            <h1 className={styles.title}>
              {headline}
            </h1>
          </Link>
          {intro && <p className={styles.intro}>{intro}</p>}
        </div>
      </div>
    </li>
  );
};

IconCTAGridItem.propTypes = {
  props: PropTypes.object,
};

export default IconCTAGridItem;
